import {ActionIcon, Tooltip} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {RenderableDocument, DibJsonNode} from "../../types";
import {extractText} from "../../contentUtils";
import {usePanel} from "../../panel/PanelContext";
import ExpandSection from "../../../../assets/expand-section.svg?react";
import {bffApi} from "../../../chat/bffApi";
import {metricUuid, newMetricEvent} from "../../../chat/metrics";

export const ExmarkLink = ({
    node,
    map,
}: {
    node: DibJsonNode;
    map: RenderableDocument;
}) => {
    const {openPanel} = usePanel();
    const {t} = useTranslation();
    const [trackInteraction] = bffApi.endpoints.trackInteraction.useMutation();

    const attrs = node.element?.attributes;
    const id = attrs?.["data-id"] ?? "";
    const title = attrs?.title || extractText(map.elements, id);
    const segmentId = attrs?.["data-segment"] ?? "preview";
    const resourceId = map.topicId;

    const handleClick = () => {
        void trackInteraction({
            ...newMetricEvent(),
            action: "content_link_opened",
            subjectId: metricUuid(map.topicId),
            linkKind: "exmark",
        });
        openPanel({
            label: title || t("word.Expand", {defaultValue: "Expand"}),
            fetchType: "documentParts",
            params: {resourceId, segmentId, id},
        });
    };

    return (
        <Tooltip
            label={t("Action.ExpandTitle", {
                title,
                defaultValue: "Utvid {{title}}",
            })}
        >
            <ActionIcon
                variant="transparent"
                color="gray"
                size="sm"
                radius="xl"
                onClick={handleClick}
                aria-label={t("Action.ExpandTitle", {
                    title,
                    defaultValue: "Utvid {{title}}",
                })}
            >
                <ExpandSection width={18} height={18} />
            </ActionIcon>
        </Tooltip>
    );
};
